















































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { getDefaultAloPartenaire } from '@/models/alo/AloPartenaire'
import * as rules from '@/utils/validationRules'

@Component({
  name: 'GestionPartenaires',  
})
export default class GestionPartenaires extends Vue {
  private loading = false
  private showError = false  
  private showNew = false
  private newPartenaire = getDefaultAloPartenaire()  
  private toolbarHeight = 50

  private get tableauHeight() {    
    return this.$store.myGetters.contentHeight - this.toolbarHeight - 25
  }

  onResize(){
    //@ts-ignore
    this.toolbarHeight = this.$refs.toolbar.$el.clientHeight
  }

  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  rulePasswordMinLength(v:string) {
    return rules.rulePasswordMinLength(v)
  }  

  ruleLoginValid(v:string) {
    return rules.ruleLoginValid(v)
  }  
  
  private get loginPrefixe() {
    return !!this.$store.myGetters.enseignes[this.$store.myGetters.userProfile.ensId]?this.$store.myGetters.enseignes[this.$store.myGetters.userProfile.ensId].ensKey.toLowerCase():''
  }

  private get newLogin(){
    return this.newPartenaire.ptnFtpLogin.replace(`${this.loginPrefixe}_`,"")
  }  

  private set newLogin(value){
    this.newPartenaire.ptnFtpLogin = `${this.loginPrefixe}_${value}`
  }

  private get partenaire() {
    return this.$store.myGetters.partenaireList
  }

  private get search(){
    return this.$store.myGetters.searchPartenaire
  }

  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_PARTENAIRE(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortPartenaireDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_PARTENAIRE_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortPartenaireBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_PARTENAIRE_BY(value)
  }

  private headers = [
    { text: 'ID', value: 'id' },
    { text: 'Partenaires', value: 'libelle' },    
    { text: 'Login', value: 'ptnFtpLogin'},
    { text: 'Nb flux', value: 'fluxIds', filterable:false },
    /*,
    { text: 'Flux', value: 'flux' },
    { text: 'Priorité', value: 'priorite' }*/
  ]

  created() {
    this.loading = true
    this.$store.myActions.CATALOGUE_REFERENCE_ENSURE()
    this.$store.myActions.ADM_PARTENAIRE_ENSURE().finally(() => {
      this.loading = false
    })
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifyPartenaires',params:{partenaireId:item.id}})    
  }

  addPartenaire() {
    this.showNew = true  
    this.newPartenaire = {...getDefaultAloPartenaire(),ensId:this.$store.myGetters.userProfile.ensId}
  }

  save(){
    if ((this.$refs.newPartenaireForm as HTMLFormElement).validate()) {    
      this.$store.myActions.ADM_PARTENAIRE_SAVE_REQUEST(this.newPartenaire).then((partenaire) => {
        this.showNew = false
        this.openDetail(partenaire)
      })    
    }
  }
}
